<div class="container banner-wrapper">
    <div class="row-auto">
        <div
            *ngIf="bannerAddress"
            [ngStyle]="{ 'background-image': 'url(\'' + bannerAddress + '\')' }"
            class="banner image"
        ></div>
    </div>
</div>
<div class="second-nav container">
    <app-info-bar
        [activeCollection]="activeCollection || collections"
        [parentCollection]="collections"
        [isCollectionPreview]="isCollectionPreview"
    ></app-info-bar>
</div>
<div class="container collection-container" *ngIf="activeCollection?.id">
    <div class="collection-wrapper row-auto">
        <div
            [ngStyle]="{ display: showSideBar() ? 'block' : 'none' }"
            class="collection-sidenav-wrapper col-xs-12 col-sm-12 col-md-3 col-lg-3"
        >
            <div class="row-auto g-0">
                <div *ngIf="collections.children.length" class="col-12 navigation">
                    <app-side-navigation
                        [activeNode]="activeCollection"
                        [gtmPrefix]="gtmPrefix"
                        [navigationNode]="collections"
                        [styles]="collections.style"
                    >
                    </app-side-navigation>
                </div>
                <div class="col-12 funders-section">
                    <app-funders [credits]="activeCollection.getCredits()" [funders]="founder">
                    </app-funders>
                </div>
            </div>
        </div>
        <div class="collection-content col px-4">
            <div [ngStyle]="setMaximumWidth()" class="collection-content-wrapper">
                <div class="collection-heading">
                    <app-collection-heading
                        [collection]="activeCollection || collections"
                    ></app-collection-heading>
                </div>
                <div *ngIf="collections.children.length" class="dropdown-navigation">
                    <span class="explore-collection">Explore Collection</span>
                    <app-side-navigation-mobile
                        [activeNode]="activeCollection"
                        [navigationNodes]="getDropDownNavigationNodes()"
                    >
                    </app-side-navigation-mobile>
                </div>
                <app-collection-description
                    *ngIf="collections.featuredAsset.mediaType && !activeCollection.parents.length"
                    [featuredAsset]="collections.featuredAsset"
                    [styles]="collections.style"
                    class="col-12 featured-asset"
                >
                </app-collection-description>
                <div *ngIf="!shouldShowEmptyMessage" class="collection-resources-wrapper">
                    <app-load-more-resources
                        *ngIf="activeCollection.children.length >= 1"
                        [collection]="activeCollection"
                    >
                    </app-load-more-resources>
                    <app-paginated-resources
                        *ngIf="activeCollection.children.length === 0"
                        [collection]="activeCollection"
                    >
                    </app-paginated-resources>
                </div>
                <div
                    class="w-100 fw-bold text-center my-7"
                    *ngIf="shouldShowEmptyMessage && !activeCollection?.children.length"
                >
                    No resources available
                    <span *ngIf="selectedFilter !== 'All grades' && isStudent">
                        for Grades {{ selectedFilter }}. Filter by All Grades to see the full
                        collection.</span
                    >
                </div>
                <div *ngFor="let subCollection of activeCollection.children">
                    <app-subcollection [collection]="subCollection" [styles]="collections.style">
                    </app-subcollection>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="col-12 funders-section-mobile" *ngIf="activeCollection?.id">
    <app-funders [credits]="activeCollection.getCredits()" [funders]="founder"> </app-funders>
</div>
<div *ngIf="attributions && attributions.length > 0" class="container-fluid contributors-section">
    <div class="container">
        <app-attributes [attributions]="attributions"></app-attributes>
    </div>
</div>
<app-available-features></app-available-features>
